import { createMmWsAction } from '@skynet/data-ws-mm';
import type {
  AddManualTransactionPayload,
  GetTransactionsPayload,
  RemoveManualTransactionPayload,
  UpdateTransactionPayload,
} from './types';
import { TransactionCommands } from './types';

export const getTransactions = createMmWsAction<GetTransactionsPayload>(
  'loans/getTransactions',
  TransactionCommands.GetTransactions,
);

export const updateTransaction = createMmWsAction<UpdateTransactionPayload>(
  'loans/updateTransaction',
  TransactionCommands.UpdateTransaction,
);

export const addManualTransaction = createMmWsAction<
  AddManualTransactionPayload,
  AddManualTransactionPayload
>(
  'shared/AddManualTransaction',
  (
    data = {
      accountID: '',
      token: '',
      amount: 0,
    },
  ) => ({
    command: TransactionCommands.AddTransaction,
    ...data,
  }),
);

export const removeManualTransaction = createMmWsAction<
  RemoveManualTransactionPayload,
  RemoveManualTransactionPayload
>(
  'shared/RemoveManualTransaction',
  (
    data = {
      accountID: '',
      transactionID: '',
    },
  ) => ({
    command: TransactionCommands.RemoveTransaction,
    ...data,
  }),
);
